<div class="container p-3">
	<it-select
		name="documentSubtype"
		[label]="'iterlex.authority' | translate"
		[(ngModel)]="currentAuthority"
		(ngModelChange)="load()"
		required
	>
		<option selected value="">
			{{ "iterlex.select-authority" | translate }}
		</option>
		@for (authority of authorities; track authority.id) {
			@if (authority.children.length > 0) {
				@for (body of authority.children; track body.id) {
					<option [value]="authority.id + '/' + body.id">
						{{
							authority.label[
								"iterlex.currentLanguage" | translate
							]
						}}
						/
						{{ body.label["iterlex.currentLanguage" | translate] }}
					</option>
				}
			} @else {
				<option [value]="authority.id + '/' + authority.id">
					{{ authority.label["iterlex.currentLanguage" | translate] }}
				</option>
			}
		}
	</it-select>
</div>
@if (currentAuthority) {
	<div class="container-fluid">
		<it-tab-container>
			<it-tab-item [label]="'iterlex.document-subtype' | translate">
				<button
					type="button"
					itButton="primary"
					(click)="createSubtypeModal.toggle()"
				>
					{{ "iterlex.create-document-subtype" | translate }}
				</button>
				<it-table itSort>
					<ng-container thead>
						<tr>
							<th it-sort-header="" scope="col">
								{{ "iterlex.id" | translate }}
							</th>
							<th it-sort-header="" scope="col">
								{{
									("iterlex.title" | translate) +
										" (" +
										("iterlex.ita" | translate) +
										")"
								}}
							</th>
							<th it-sort-header="" scope="col">
								{{
									("iterlex.title" | translate) +
										" (" +
										("iterlex.deu" | translate) +
										")"
								}}
							</th>
							<th scope="col">
								{{ "iterlex.order" | translate }}
							</th>
							<th scope="col">
								{{ "iterlex.actions" | translate }}
							</th>
						</tr>
					</ng-container>
					<ng-container tbody>
						@for (
							documentSubtype of documentSubtypes;
							track documentSubtype.id
						) {
							<tr>
								<th>
									{{ documentSubtype.documentType }} /
									{{ documentSubtype.id }}
								</th>
								<td>
									{{ documentSubtype.label["it"] }}
								</td>
								<td>
									{{ documentSubtype.label["de"] }}
								</td>
								<td>
									{{ documentSubtype.order }}
								</td>
								<td>
									<button
										type="button"
										itButton="primary"
										class="me-2"
										size="xs"
										(click)="
											currentDocumentSubtype =
												documentSubtype;
											editSubtypeModal.toggle()
										"
									>
										{{ "it.general.edit" | translate }}
									</button>
									<button
										type="button"
										itButton="outline-danger"
										size="xs"
										(click)="
											currentDocumentSubtype =
												documentSubtype;
											deleteSubtypeModal.toggle()
										"
									>
										{{ "it.core.remove" | translate }}
									</button>
								</td>
							</tr>
						}
					</ng-container>
				</it-table>
			</it-tab-item>
			<it-tab-item [label]="'iterlex.dossier-type' | translate">
				<it-table itSort>
					<ng-container thead>
						<tr>
							<th it-sort-header="" scope="col">
								{{ "iterlex.id" | translate }}
							</th>
							<th it-sort-header="" scope="col">
								{{
									("iterlex.title" | translate) +
										" (" +
										("iterlex.ita" | translate) +
										")"
								}}
							</th>
							<th it-sort-header="" scope="col">
								{{
									("iterlex.title" | translate) +
										" (" +
										("iterlex.deu" | translate) +
										")"
								}}
							</th>
							<th scope="col">
								{{ "iterlex.actions" | translate }}
							</th>
						</tr>
					</ng-container>
					<ng-container tbody>
						@for (
							dossierType of dossierTypes;
							track dossierType.id
						) {
							<tr>
								<th>
									{{ dossierType.id }}
								</th>
								<td>
									{{ dossierType.label["it"] }}
								</td>
								<td>
									{{ dossierType.label["de"] }}
								</td>
								<td>
									<button
										type="button"
										itButton="primary"
										class="me-2"
										size="xs"
										(click)="
											currentDossierType = dossierType;
											loadDossierPhases();
											dossierPhasesModal.toggle()
										"
									>
										{{
											"iterlex.dossier-phases" | translate
										}}
									</button>
								</td>
							</tr>
						}
					</ng-container>
				</it-table>
			</it-tab-item>
		</it-tab-container>
	</div>
	<it-modal #createSubtypeModal size="lg">
		<ng-container modalTitle>{{
			"iterlex.create-document-subtype" | translate
		}}</ng-container>
		<form
			#createSubtypeForm="ngForm"
			(ngSubmit)="onCreateSubtypesSubmit(createSubtypeForm)"
		>
			<it-select
				name="documentType"
				ngModel
				[label]="'iterlex.document-type' | translate"
				required
			>
				<option selected value="">
					{{ "iterlex.select-document-type" | translate }}
				</option>
				@for (documentType of documentTypes; track documentType.id) {
					<option [value]="documentType.id">
						{{ documentType.id }}
					</option>
				}
			</it-select>
			<it-input
				type="text"
				name="id"
				ngModel
				required
				[label]="'iterlex.id' | translate"
			></it-input>
			<it-input
				type="text"
				name="labelITA"
				ngModel
				required
				[label]="
					('iterlex.title' | translate) +
					' (' +
					('iterlex.ita' | translate) +
					')'
				"
			></it-input>
			<it-input
				type="text"
				name="labelDEU"
				ngModel
				required
				[label]="
					('iterlex.title' | translate) +
					' (' +
					('iterlex.deu' | translate) +
					')'
				"
			></it-input>
			<it-input
				type="number"
				name="order"
				ngModel
				required
				[label]="'iterlex.order' | translate"
			></it-input>
			<button
				itButton="primary"
				type="submit"
				[disabled]="!createSubtypeForm.valid"
				data-bs-dismiss="modal"
			>
				{{ "iterlex.create-document-subtype" | translate }}
			</button>
		</form>
		<ng-container footer><span></span></ng-container>
	</it-modal>
	<it-modal #editSubtypeModal size="lg">
		<ng-container modalTitle>{{
			"it.general.edit" | translate
		}}</ng-container>
		<form
			#editSubtypeForm="ngForm"
			(ngSubmit)="onEditSubtypesSubmit(editSubtypeForm)"
		>
			@if (currentDocumentSubtype) {
				<it-select
					name="documentType"
					[ngModel]="currentDocumentSubtype.documentType"
					[label]="'iterlex.document-type' | translate"
					required
				>
					<option selected value="">
						{{ "iterlex.select-document-type" | translate }}
					</option>
					@for (
						documentType of documentTypes;
						track documentType.id
					) {
						<option [value]="documentType.id">
							{{ documentType.id }}
						</option>
					}
				</it-select>
				<it-input
					type="text"
					name="id"
					[ngModel]="currentDocumentSubtype.id"
					required
					[label]="'iterlex.id' | translate"
				></it-input>
				<it-input
					type="text"
					name="labelITA"
					[ngModel]="currentDocumentSubtype.label['it']"
					required
					[label]="
						('iterlex.title' | translate) +
						' (' +
						('iterlex.ita' | translate) +
						')'
					"
				></it-input>
				<it-input
					type="text"
					name="labelDEU"
					[ngModel]="currentDocumentSubtype.label['de']"
					required
					[label]="
						('iterlex.title' | translate) +
						' (' +
						('iterlex.deu' | translate) +
						')'
					"
				></it-input>
				<it-input
					type="number"
					name="order"
					[ngModel]="currentDocumentSubtype.order"
					required
					[label]="'iterlex.order' | translate"
				></it-input>
				<button
					itButton="primary"
					type="submit"
					[disabled]="!editSubtypeForm.valid"
					data-bs-dismiss="modal"
				>
					{{ "it.general.edit" | translate }}
				</button>
			}
		</form>
		<ng-container footer><span></span></ng-container>
	</it-modal>
	<it-modal
		#deleteSubtypeModal="itModal"
		closeButton="false"
		popconfirm="true"
	>
		<ng-container modalTitle>{{
			"iterlex.delete-document-subtype-confirm" | translate
		}}</ng-container>
		@if (currentDocumentSubtype) {
			<p>
				{{
					"iterlex.delete-document-subtype-confirm-description"
						| translate: { name: currentDocumentSubtype.id }
				}}
			</p>
		}
		<ng-container footer>
			@if (currentDocumentSubtype) {
				<button
					itButton="danger"
					type="button"
					data-bs-dismiss="modal"
					(click)="deleteSubtype()"
				>
					{{ "it.core.remove" | translate }}
				</button>
			}
			<button
				itButton="outline-secondary"
				type="button"
				data-bs-dismiss="modal"
			>
				{{ "iterlex.cancel" | translate }}
			</button>
		</ng-container>
	</it-modal>
	<it-modal #dossierPhasesModal size="lg">
		<ng-container modalTitle>{{
			"iterlex.dossier-phases" | translate
		}}</ng-container>
		<form
			#dossierPhasesForm="ngForm"
			(ngSubmit)="addPhaseToDossierType(dossierPhasesForm)"
		>
			<div class="d-flex align-items-start">
				<it-select
					#documentTypeSelect
					name="phase"
					ngModel
					[label]="'iterlex.dossier-phases' | translate"
					required
				>
					<option selected value=""></option>
					@for (phase of phases; track phase.id) {
						<option [value]="phase.id">
							{{
								phase.label[
									"iterlex.currentLanguage" | translate
								]
							}}
						</option>
					}
				</it-select>
				<button
					class="ms-2"
					type="submit"
					size="xs"
					itButton="outline-primary"
					[disabled]="!dossierPhasesForm.valid"
				>
					<it-icon name="plus"></it-icon>
				</button>
			</div>
		</form>
		<ul>
			@for (dossierPhase of currentDossierPhases; track dossierPhase.id) {
				<li>
					<button
						type="button"
						itButton="outline-primary"
						size="xs"
						class="me-2"
						[disabled]="$last"
						(click)="orderPhase($index, 1)"
					>
						<it-icon name="arrow-down"></it-icon>
					</button>
					<button
						type="button"
						itButton="outline-primary"
						size="xs"
						class="me-2"
						[disabled]="$first"
						(click)="orderPhase($index, -1)"
					>
						<it-icon name="arrow-up"></it-icon>
					</button>
					<button
						type="button"
						itButton="outline-danger"
						size="xs"
						(click)="deletePhaseFromDossierType(dossierPhase.id)"
					>
						<it-icon
							name="delete"
							color="danger"
							[title]="'it.core.remove' | translate"
						></it-icon>
					</button>
					{{
						dossierPhase.label[
							"iterlex.currentLanguage" | translate
						]
					}}
				</li>
			}
		</ul>
		<ng-container footer><span></span></ng-container>
	</it-modal>
}
